module.exports = "/assets/data/e2ca0fc0b33c4f9bf30c9e3cda07629e-BD7.data.json";